import snakecaseKeys from 'snakecase-keys'
import camelcaseKeys from 'camelcase-keys'
import axiosIns from '@/plugins/axios'

export default {
  // 日払い明細プレビュー(サーバー側でBRR/Timecardから組み立てたスナップショット)
  // レスポンスはcamelCaseへ変換して返す
  async getPreview({ userId, targetDate, displayMode }) {
    const response = await axiosIns.get(
      '/admin/advance_payment_confirmations/preview',
      {
        params: snakecaseKeys({
          userId,
          targetDate,
          displayMode,
        }),
      },
    )

    return camelcaseKeys(response.data, { deep: true })
  },

  // 署名画像のみ送信する。明細スナップショットはサーバー側で再計算して確定される
  create({
    userId, targetDate, displayMode, signatureImage,
  }) {
    const formData = new FormData()
    formData.append('user_id', userId)
    formData.append('target_date', targetDate)
    formData.append('display_mode', displayMode)
    formData.append('signature_image', signatureImage, 'signature.png')

    return axiosIns.post(
      '/admin/advance_payment_confirmations',
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
      },
    )
  },

  // 明細のレシート印刷(SDP限定)。印字内容はサーバー側で電子サインと同じスナップショットから組み立てる。
  // signature({ raster, width, height })は任意。あればサイン欄に画像として印字される
  print({
    userId, targetDate, displayMode, signature = null,
  }) {
    return axiosIns.post(
      '/admin/advance_payment_confirmations/print',
      snakecaseKeys({
        userId,
        targetDate,
        displayMode,
        signature,
      }),
    )
  },
}
